import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  AnalyticsQueryParams,
  FetchCompaniesPaymentsFlowResponse,
  FetchPaymentsFlowResponse,
  FetchPurchasesFlowResponse,
} from './analytics.types';
import {
  getCompaniesPaymentsFlow,
  getPaymentsFlow,
  getPurchasesFlow,
} from './analytics.api';

const prefix = 'analytics';

export const fetchCompaniesPaymentsFlowAction = createAsyncThunkFromFetch<
  FetchCompaniesPaymentsFlowResponse,
  { params?: AnalyticsQueryParams }
>(`${prefix}/fetchCompaniesPayments`, getCompaniesPaymentsFlow);

export const fetchPaymentsFlowAction = createAsyncThunkFromFetch<
  FetchPaymentsFlowResponse,
  { companyId: string; params?: AnalyticsQueryParams }
>(`${prefix}/fetchPayments`, getPaymentsFlow);

export const fetchPurchasesFlowAction = createAsyncThunkFromFetch<
  FetchPurchasesFlowResponse,
  { companyId: string; params?: Omit<AnalyticsQueryParams, 'aggregation'> }
>(`${prefix}/fetchPurchasesFlow`, getPurchasesFlow);
